import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row } from "reactstrap";
import {
    getAllBatchesApi,
    getAllDashboardUsersApi,
    getAllUsersApi,
    getbatchFeesListApi,
    getFeesListApi,
    getFollowUpsByEnquiryApi,
    getPaymentHistoryApi,
    searchBatchApi,
} from "../../api/apiUrlConst";

import CreateBatchModal from "../../Components/Batch/CreateBatchModal";
import BatchTable from "../../Components/Batch/BatchTable";
import EditBatchModal from "../../Components/Batch/EditBatchModal";
import BatchStudentsModal from "../../Components/Batch/BatchStudentsModal";
import StudentHistoryModal from "../../Components/Batch/StudentHistoryModal";
import Coordinatorbatchtable from "../../Components/Batch/Coordinatorbatchtable";

const BatchManagement = () => {
    const [batches, setBatches] = useState<any[]>([]);
    const [filteredBatches, setFilteredBatches] = useState<any[]>([]);
    const [search, setSearch] = useState("");

    const [createModal, setCreateModal] = useState(false);
    const [studentModal, setStudentModal] = useState(false);

    const [selectedBatchId, setSelectedBatchId] = useState<number | null>(null);
    const [editModal, setEditModal] = useState(false);
    const [selectedBatch, setSelectedBatch] = useState<any>(null);
    const [historyModal, setHistoryModal] = useState(false);
const [selectedStudent, setSelectedStudent] = useState<any>(null);
const [payments, setPayments] = useState<any[]>([]);
const [followups, setFollowups] = useState<any[]>([]);
const [students, setStudents] = useState<any[]>([]);
const [statusFilter, setStatusFilter] = useState("");
const [users, setUsers] = useState<any[]>([]);
const [userfilter, setuserfilter] = useState("");
const role = sessionStorage.getItem("role");
const [allUsers, setAllUsers] = useState<any[]>([]);
const [coordinatorUsers, setCoordinatorUsers] = useState<any[]>([]);

useEffect(() => {
  if (role === "Admin") {
    loadUsers();
  }

  if (role === "Coordinator") {
    loadCoordinatorUsers();
  }
}, []);

const loadUsers = async () => {
  try {
    const data = await getAllUsersApi();
    setAllUsers(data);
  } catch (error) {
    console.error(error);
  }
};
const loadCoordinatorUsers = async () => {
  try {
    const data = await getAllDashboardUsersApi();
    setCoordinatorUsers(data);
  } catch (error) {
    console.error(error);
  }
};

const handleStudentsHistory = async (batch: any) => {

  try {

    // Get all fees list
    const feesList = await getbatchFeesListApi();

    const formattedStudents = batch.students.map((s: any) => {

      const enq = s.enqForm;

      // match using enqFormId
      const studentFees = feesList.find(
        (f: any) => f.enqFormId === enq.id
      );

      const totalFees = studentFees?.totalFees || 0;
      const paidAmount = studentFees?.paidAmount || 0;
      const pendingAmount = studentFees?.pendingAmount || 0;

      return {
        id: s.id,
        enqFormId: enq.id,
        eid: enq.eid,
        name: enq.name,
        phoneNo: enq.phoneNumber,
        course: enq.courseName,
        batchName: batch.batchName,

        totalFees: totalFees,
        paidAmount: paidAmount,
        pendingAmount: pendingAmount,
        nextDueDate: studentFees?.nextDueDate || null
      };

    });

    console.log("Formatted Students:", formattedStudents);

    setStudents(formattedStudents);
    setHistoryModal(true);

  } catch (error) {
    console.error("Error loading student history:", error);
  }

};

 useEffect(() => {
  let data = [...batches];

  // 🔍 Search Filter
  if (search) {
    const searchLower = search.toLowerCase();

    data = data.filter((b) =>
      b.batchName?.toLowerCase().includes(searchLower) ||
      b.course1Name?.toLowerCase().includes(searchLower) ||
      b.course2Name?.toLowerCase().includes(searchLower)
    );
  }

  // 🎯 Status Filter
  if (statusFilter) {
    data = data.filter((b) => b.batch1Status === statusFilter);
  }
  if (userfilter) {
    data = data.filter((b) => b.createdByCoordinatorId === userfilter);
  }

  setFilteredBatches(data);

}, [search, statusFilter, batches,userfilter]);

    const loadBatches = async () => {
        const res = await getAllBatchesApi();
        setBatches(res);
        setFilteredBatches(res);
    };

    useEffect(() => {
        loadBatches();
    }, []);



    const handleViewStudents = (batchId: number) => {
        setSelectedBatchId(batchId);
        setStudentModal(true);
    };
   
    const handleEditBatch = (batch: any) => {
        setSelectedBatch(batch);
        setEditModal(true);
    };

    const ClearFilter = () => {
      setSearch("");
      setStatusFilter("");
    };

    return (
        <div
  className="p-4 mb-4"
  style={{
    background: "linear-gradient(90deg,#374151,#093d92)",
    borderRadius: "16px",
    color: "#fff"
  }}
>

  <Row className="align-items-center g-3">

    {/* Title */}
    <Col md="3" className="p-3">
      <h4 className="fw-bold mb-0">Batch Management</h4>
      <small>Manage training batches</small>
    </Col>

    {/* Total Count */}
    <Col md="1">
      <span
        style={{
          background: "#ffffff22",
          padding: "6px 14px",
          borderRadius: "20px",
          fontSize: "13px",
          display: "inline-block"
        }}
      >
        Total: {batches.length}
      </span>
    </Col>

    {/* Search */}
    <Col md="2">
      <Input
        placeholder="🔍 Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="rounded-pill shadow-sm"
      />
    </Col>
    <Col md="2">
    <Input
  type="select"
  value={statusFilter}
  onChange={(e) => setStatusFilter(e.target.value)}
>
  <option value="">All Status</option>
  <option value="NotStarted">Not Started</option>
  <option value="Upcoming">Upcoming</option>
  <option value="Ongoing">Ongoing</option>
  <option value="Completed">Completed</option>
</Input>
        
   </Col> 

   <Col md="1">
   <Button
   color="primary"
   onClick={ClearFilter}
   >Clear</Button></Col>

    {/* Create Button */}
   {role === "Coordinator" && (
  <Col md="3" className="text-md-end">
    <Button
      className="rounded-pill px-4"
      style={{
        background: "#20c997",
        border: "none"
      }}
      onClick={() => setCreateModal(true)}
    >
      + Create Batch
    </Button>
  </Col>
)}
  </Row>

         {role === "Admin" && ( <BatchTable
  batches={filteredBatches}
  onViewStudents={handleViewStudents}
  onStudentHistory={handleStudentsHistory}
/>)}

 {role === "Coordinator" && (
          <Coordinatorbatchtable
  batches={filteredBatches}
  onViewStudents={handleViewStudents}
  onEditBatch={handleEditBatch}
  onStudentHistory={handleStudentsHistory}
/>  )}

<StudentHistoryModal
  isOpen={historyModal}
  toggle={() => setHistoryModal(false)}
  students={students}
  batchName={selectedBatch?.batchName}
/>    

            <CreateBatchModal
                isOpen={createModal}
                toggle={() => setCreateModal(false)}
                reloadBatches={loadBatches}
            />

            <BatchStudentsModal
                batchId={selectedBatchId}
                isOpen={studentModal}
                toggle={() => setStudentModal(false)}
            />

            <EditBatchModal
                isOpen={editModal}
                toggle={() => setEditModal(false)}
                batch={selectedBatch}
                reloadBatches={loadBatches}
            />
            

        </div>
    );
};

export default BatchManagement;